import "./style.scss";
import $ from "jquery";

$(document).ready(function () {
    $('.block-toggle-radio__change').click(function () {
        if (!$(this).hasClass("active")) {
            var current = $(this);
            $('.block-toggle-radio__change').removeClass("active");
            $('.block-toggle-radio__change').each(function(){
                var razred = $(this).data("razred");
                $('.'+razred).hide();
            });

            current.addClass("active");
            $('.' + current.data("razred")).show();
        }
    });
    $(".block-toggle-radio__change:first-child").trigger('click');
});